import { OrganizationLicenseTypeEntity } from '../entities/';
import { authResource } from './Auth';
export const OrganizationLicenseTypeResource = authResource({
    path: '/organizations/:organizationId/licensetypes/:organizationLicenseTypeId',
    schema: OrganizationLicenseTypeEntity
});
